module.exports = __webpack_public_path__ + "static/img/days.f333f135.png";